var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66564 18.4999H19.0878C19.2441 18.4999 19.3951 18.4453 19.5149 18.3456C19.6822 18.2055 23.4994 14.9217 23.7322 7.83332H5.0211C4.78923 14.2677 1.27378 17.292 1.23725 17.3222C1.02307 17.5032 0.944269 17.7988 1.04062 18.0618C1.13631 18.3242 1.38569 18.4999 1.66564 18.4999ZM23.0878 3.83333H19.7544V3.16666C19.7544 2.79333 19.4611 2.5 19.0878 2.5C18.7144 2.5 18.4211 2.79333 18.4211 3.16666V3.83333H15.0433V3.16666C15.0433 2.79333 14.75 2.5 14.3767 2.5C14.0033 2.5 13.71 2.79333 13.71 3.16666V3.83333H10.3767V3.16666C10.3767 2.79333 10.0834 2.5 9.71002 2.5C9.33669 2.5 9.04335 2.79333 9.04335 3.16666V3.83333H5.71003C5.3367 3.83333 5.04337 4.12666 5.04337 4.49999V6.49999H23.7544V4.49999C23.7544 4.12666 23.4611 3.83333 23.0878 3.83333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3711 19.368C20.0091 19.6694 19.5547 19.8335 19.0879 19.8335H5.04346V21.8335C5.04346 22.202 5.34163 22.5002 5.71012 22.5002H23.0878C23.4563 22.5002 23.7545 22.202 23.7545 21.8335V14.3604C22.4692 17.5137 20.6756 19.1131 20.3711 19.368Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fe613ae8.svg";
export { ForwardRef as ReactComponent };